import { Builder } from '@builder.io/react';
import { Input } from './input.component';

/**
 * <AuthBlock /> componets building
 */
const componentBuildInput = () => {
  Builder.registerComponent(Input, {
    name: 'InputComponent',
    inputs: [{ name: 'name', type: 'string', defaultValue: 'Name' }]
  });
};

export { componentBuildInput };
